require('./bootstrap');

$(function () {
    $(window).on('scroll', function() {

    });

    $(window).on('resize', function() {
        setBrowserHeights();
    });

    $(window).on('load', function() {
        setBrowserHeights();
        // alert('1');
        // setTimeout(function() {
        //     setBrowserHeights(); //chrome
        //     alert('2');
        // }, 100);
    });
    setBrowserHeights();
    reloadTooltips();

    
    Livewire.on('modal.hide', payload => {
        $(payload).modal('hide');
    });

    Livewire.on('modal.show', payload => {
        $(payload).modal('show');
    });

    Livewire.on('reload.tooltips', payload => {
        reloadTooltips();
        reloadClipboard();
    });

    $('[data-maptype]').each(function() {
        initializeMap( $(this) );
    });
    reloadClipboard();
    
});

function setBrowserHeights() {
    // console.log('setBrowserHeights');
    $('.window-height').each(function() {
        // console.log($(this));
        $(this).height( ($(window).outerHeight() * 1) );
    });
    $('.half-height').each(function() {
        // console.log($(this));
        $(this).height( ($(window).outerHeight() * 0.5) );
    });
    $('.threequarter-height').each(function() {
        // console.log($(this));
        $(this).height( ($(window).outerHeight() * 0.75) );
    });
}

function reloadClipboard() {
    $('[data-copy]').on('click', function(e) {
        e.preventDefault();
        var __input = '<input id="clipboard-data" value="'+$(this).data('copy')+'">';
        var __alert = '<span id="clipboard-alert" class="small">copied</span>';
        $(this).after(__input).append(__alert);
        var input = $('#clipboard-data');
        var alert = $('#clipboard-alert');
        input.select();
        // input.setSelectionRange(0, 99999);
        document.execCommand('copy');
        $(this).addClass('copied').delay(1500).queue(function(){
            $(this).removeClass('copied').dequeue();
            input.remove();
            alert.remove();
        });
        // var tooltip = document.getElementById("myTooltip");
        // tooltip.innerHTML = "Copied: " + copyText.value;
        
    });
}


function reloadTooltips() {
    $('[data-bs-toggle="tooltip"]').tooltip('dispose');
    $('[data-bs-toggle="tooltip"]').tooltip();
}

function initializeMap(el) {    
    if (el.length) {
        var maptype = el.data('maptype');
        var markers = el.data('markers');

        //https://jsonformatter.org/json-viewer compact
        // var mapstyles = [{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"saturation":"0"},{"lightness":"0"},{"gamma":"1"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#e3e3e3"}]},{"featureType":"landscape.natural","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"color":"#cccccc"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"transit.line","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.airport","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"transit.station.airport","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#FFFFFF"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]}];
        var mapstyles = [{"featureType":"administrative.country","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.locality","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#606464"}]},{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"visibility":"simplified"},{"hue":"#0066ff"},{"saturation":74},{"lightness":100}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#f1f6ef"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"off"},{"weight":0.6},{"saturation":-85},{"lightness":61}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"all","stylers":[{"visibility":"on"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"simplified"},{"color":"#5f94ff"},{"lightness":26},{"gamma":5.86}]}];
        
        if (google && maptype) {
            if (typeof _markerpath !== 'undefined') {
                var img = new google.maps.MarkerImage(
                    _markerpath,
                    new google.maps.Size(41, 41),
                    new google.maps.Point(0,0),
                    new google.maps.Point(20, 20)
                );
            }

            var map = new google.maps.Map(document.getElementById(el.attr('id')), {
                // zoom: 14,
                // controlSize: 24,
                styles: mapstyles,
                mapTypeControl: true,
                mapTypeControlOptions: {
                    style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
                    position: google.maps.ControlPosition.LEFT_CENTER,
                },
                // zoomControl: true,
                // zoomControlOptions: {
                //   position: google.maps.ControlPosition.LEFT_CENTER,
                // },
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER,
                },
                cameraControl: false,
                cameraControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER,
                },
                mapTypeControl: true,
                scaleControl: true,
                streetViewControl: false,
                mapTypeId: _maptype,
                // rotateControl: true,
                // fullscreenControl: true
            }); 

            var bounds = new google.maps.LatLngBounds();
            var infowindow = new google.maps.InfoWindow();

            var i = 0;
            var geo;
            while (i < markers.length) {
                switch (maptype) {
                    case 'single':
                        geo = markers[i];
                        break;

                    case 'multiple':
                        geo = markers[i].geo;
                        break;
                }

                var pos = new google.maps.LatLng(geo.lat, geo.lng);
                if (typeof img !== 'undefined') {
                    var marker = new google.maps.Marker({
                        icon: img,
                        map: map,
                        position: pos
                    });
                }
                bounds.extend(pos);

                switch (maptype) {
                    case 'multiple':
                        google.maps.event.addListener(marker,'click', (function(marker, content, infowindow){ 
                            return function() {
                                infowindow.setContent(content);
                                infowindow.open(map,marker);
                            };
                        })(marker, markers[i].html, infowindow));
                        // var infowindow = new google.maps.InfoWindow({
                        //     content: markers[i].html,
                        //     ariaLabel: markers[i].name,
                        // });

                        // google.maps.event.addListener(marker, 'click', (function(marker, infowindow){ 
                        //     return function() {
                        //         infowindow.open(map, marker);
                        //         google.maps.event.addListener(map,'click', function(){ 
                        //             infowindow.close();
                        //         });
                        //         google.maps.event.addListener(map,'click', function(){ 
                        //             infowindow.close();
                        //         }); 
                        //     };
                        // })(marker, infowindow));
                        break;
                }
                i++;
            }
            // map.setCenter(pos);
            switch (maptype) {
                case 'single':
                    map.setCenter(pos);
                    map.setZoom(_zoom);
                    break;
                
                case 'multiple':
                    map.fitBounds(bounds);
                    google.maps.event.addDomListener(window, 'resize', function() {
                        map.fitBounds(bounds);
                    });
                    setTimeout(function() {
                        map.fitBounds(bounds);
                    }, 1000);
                    break;
            }

            el.addClass('h-100').addClass('w-100');
        }
    }
}